import { render, staticRenderFns } from "./List-import-colaborador.vue?vue&type=template&id=91f948b4&scoped=true&"
import script from "./List-import-colaborador.vue?vue&type=script&lang=js&"
export * from "./List-import-colaborador.vue?vue&type=script&lang=js&"
import style0 from "./List-import-colaborador.vue?vue&type=style&index=0&id=91f948b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f948b4",
  null
  
)

export default component.exports